import tippy, { roundArrow } from 'tippy.js';

// FIXME Replace w/ floating-ui

const TooltipHook = {
  mounted() {
    const target = this.el.dataset.target && document.getElementById(this.el.dataset.target);
    const message = this.el.dataset.message;
    const placement = this.el.dataset.placement || 'top';
    const interactive = this.el.dataset.interactive !== undefined;

    tippy(this.el, {
      theme: 'light-border',
      arrow: roundArrow,
      content: message || target.innerHTML,
      maxWidth: 420,
      allowHTML: true,
      placement: placement,
      interactive: interactive,
      appendTo: () => document.body,
    });
  },
};

export default TooltipHook;
